// Components==============
import React, { useState } from 'react';
import './Footer.module.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopyright } from '@fortawesome/pro-regular-svg-icons';
// =========================

export default function Footer() {
    const [activeGiff, setActiveGiff] = useState<String>(
        '/images/studio-footer/idle.gif'
    );
    return (
        <>
            <div styleName="footer">
                <div styleName="left">
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://opdidakt.nl/spiek-digitaal/"
                    >
                        <FontAwesomeIcon icon={faCopyright} /> Opdidakt | 2021
                    </a>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.instagram.com/opdidakt/"
                    >
                        <img
                            styleName="social-icon"
                            src="/images/fontawesome-brands/instagram-brands.svg"
                            alt="instagram logo"
                        />
                    </a>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.facebook.com/opdidakt"
                    >
                        <img
                            styleName="social-icon"
                            src="/images/fontawesome-brands/facebook-brands.svg"
                            alt="facbook logo"
                        />
                    </a>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.linkedin.com/company/opdidakt-b-v-/"
                    >
                        <img
                            styleName="social-icon"
                            src="/images/fontawesome-brands/linkedin-brands.svg"
                            alt="linkedin logo"
                        />
                    </a>
                </div>
                <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.studiotast.com/"
                    styleName="right"
                    onMouseOver={() => {
                        setActiveGiff('/images/studio-footer/hover.gif');
                    }}
                    onMouseLeave={() => {
                        setActiveGiff('/images/studio-footer/idle.gif');
                    }}
                    onFocus={() => {
                        setActiveGiff('/images/studio-footer/hover.gif');
                    }}
                >
                    <p>
                        With a<br /> touch of{' '}
                    </p>
                    <img alt="squigly diggly" src={`${activeGiff}`} />
                </a>
            </div>
        </>
    );
}
